import { faCheck, faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

const CopyableInput = ({ value, isTextArea, rows }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(value).then(() => {
            setIsCopied(true);

            setTimeout(() => {
                setIsCopied(false);
            }, 3000);
        });
    };

    return (
        <>
            <div className="input-group input-group-sm">
                {isTextArea ? (
                    <textarea value={value} disabled className='form-control' rows={rows} />
                ) : (
                    <input type="text" value={value} disabled className='form-control' />
                )}
                <button className="btn btn-outline-dark" type="button" onClick={handleCopy} disabled={isCopied}>
                    <span className={isCopied ? 'text-success' : ''}>
                        <FontAwesomeIcon icon={isCopied ? faCheck : faCopy} fixedWidth /> {isCopied ? 'Copied' : 'Copy'}
                    </span>
                </button>
            </div>
        </>
    );
};

export default CopyableInput;